import { ICalculatorField } from '../hooks';

export const loadFieldsFromLocalstorage = ({
  setFields,
  setTargetMoisture,
  setEnableMoistenUnmixed,
}: {
  setFields: (val: ICalculatorField[]) => void;
  setTargetMoisture: (val: number) => void;
  setEnableMoistenUnmixed: (val: boolean) => void;
}) => {
  const fields = localStorage.getItem('calculatorFields');
  if (fields) setFields(JSON.parse(fields));

  const enableMoistenUnmixed = localStorage.getItem('enableMoistenUnmixed');
  if(enableMoistenUnmixed) setEnableMoistenUnmixed(JSON.parse(enableMoistenUnmixed))

  const targetMoisture = localStorage.getItem('targetMoisture');
  if (targetMoisture) setTargetMoisture(JSON.parse(targetMoisture));
};
